<div class="menu-container mb-2">
  @for (benefitCategory of sideTimelineList; track benefitCategory) {
    <div
      class="menu-selection"
        [ngClass]="{'active': benefitCategory.id == enrollmentManagerService.manager.selectedCategoryId,
                'required': benefitCategory.isRequired,
                'completed': benefitCategory.isCompleted,
                'disabled': benefitCategory.isDisabled
            }" (click)="categoryChange(benefitCategory)">
      <div class="select-left-tab">
        @if (benefitCategory.isCompleted) {
          <mwp-svg-icon [SvgMatType]="svgType.CheckMark"/>
        }
        @if (benefitCategory.isRequired && !benefitCategory.isCompleted) {
          <div class="requiredCircle">
            <div class="redCircle"></div>
          </div>
        }
        @if (!benefitCategory.isRequired && !benefitCategory.isCompleted) {
          <div class="no-format"></div>
        }
      </div>
      <div class="select-right-tab">
        <span>
          {{ benefitCategory.name }}
        </span>
      </div>
    </div>
  }
</div>